import React, { useMemo } from 'react';
import { tex } from './textures';

const Plane = ({ w, d, y, kind, x = 0, z = 0 }) => (
  <mesh rotation={[-Math.PI / 2, 0, 0]} position={[x, y, z]} receiveShadow>
    <planeGeometry args={[w, d]} />
    <meshStandardMaterial map={tex(kind, w, d)} roughness={1} />
  </mesh>
);

const Tree = ({ p, s }) => (
  <group position={p} scale={s}>
    <mesh position={[0, 0.9, 0]} castShadow><cylinderGeometry args={[0.12, 0.18, 1.8, 6]} /><meshStandardMaterial color="#4a3826" roughness={1} /></mesh>
    <mesh position={[0, 2.6, 0]} castShadow><icosahedronGeometry args={[1.6, 0]} /><meshStandardMaterial color="#2f4a2a" roughness={0.9} flatShading /></mesh>
    <mesh position={[0.3, 3.6, -0.2]} castShadow><icosahedronGeometry args={[1.05, 0]} /><meshStandardMaterial color="#3a5a32" roughness={0.9} flatShading /></mesh>
  </group>
);

export const Site = ({ W, D, size, wings = [] }) => {
  const g = -0.6;
  const trees = useMemo(() => {
    const out = [];
    const ox = W / 2 + 11, oz = D / 2 + 13;
    const per = 2 * (2 * ox + 2 * oz);
    const n = Math.min(30, Math.max(8, Math.round(per / 10)));
    for (let i = 0; i < n; i += 1) {
      let t = (i / n) * per;
      let x, z;
      if (t < 2 * ox) { x = -ox + t; z = -oz; } else if ((t -= 2 * ox) < 2 * oz) { x = ox; z = -oz + t; } else if ((t -= 2 * oz) < 2 * ox) { x = ox - t; z = oz; } else { t -= 2 * ox; x = -ox; z = oz - t; }
      const j = ((i * 37) % 11) / 11;
      out.push({ p: [x + (j - 0.5) * 3, g, z + (0.5 - j) * 3], s: 0.8 + j * 0.6 });
    }
    return out;
  }, [W, D]);
  const stripes = useMemo(() => {
    const n = Math.min(40, Math.floor(W / 2.6));
    return Array.from({ length: n }, (_, i) => -((n - 1) * 2.6) / 2 + i * 2.6);
  }, [W]);
  return (
    <group>
      <Plane w={size * 10} d={size * 10} y={g - 0.01} kind="grass" />
      <Plane w={W + 20} d={D + 22} y={g} kind="asphalt" />
      {wings.map((wg, i) => (
        <Plane key={i} w={wg.w + 5} d={wg.d + 5} y={g + 0.01 + i * 0.001} kind="paving" x={wg.x + wg.w / 2 - W / 2} z={wg.y + wg.d / 2 - D / 2} />
      ))}
      {stripes.map((x) => (
        <mesh key={x} position={[x, g + 0.012, -D / 2 - 8]} rotation={[-Math.PI / 2, 0, 0]}>
          <planeGeometry args={[0.12, 4.6]} /><meshBasicMaterial color="#d9d4cc" />
        </mesh>
      ))}
      {trees.map((t, i) => <Tree key={i} {...t} />)}
    </group>
  );
};
